import React from 'react';
import { Box, Text } from '@chakra-ui/react';

export const MainPageHeader: React.FC<{
  name: string;
  type: string;
  address?: string;
}> = ({ name, type, address }) => {
  return (
    <Box>
      <Text color="black" textStyle="h4" translate="no">
        {name}
      </Text>
      <Text color="grayText" textStyle="body1" translate="no">
        {type}
      </Text>
      <Text color="grayText" textStyle="body1" translate="no">
        {address}
      </Text>
    </Box>
  );
};
